<app-input-select
  idField="istatRegione"
  labelField="denominazioneRegione"
  [list]="regioni"
  [name]="name"
  label="Regione"
  icon="south_america"
  [form]="form"
  [searchComponentTemplate]="searchTemplate"
  placeholder="Seleziona una regione"
>
</app-input-select>
